import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { setSsrOrigin } from "./lib/site-origin";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  try {
    // Capture the request origin so head() can emit absolute og:image /
    // twitter:image URLs — social crawlers reject relative ones.
    try {
      const url = new URL((request as Request).url);
      const forwardedHost = url.hostname === "localhost" ? request.headers.get("x-forwarded-host") : null;
      setSsrOrigin(forwardedHost ? `https://${forwardedHost}` : url.origin);
    } catch {
      /* origin stays unset — head() falls back to relative image paths */
    }
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [errorMiddleware],
}));
